import gql from "graphql-tag";

export const updatePassword = gql`
    mutation updateClient (
        $password: String!
        $password_token: String!
    ) {
        updateClient (
            input: {
                password: $password
                password_token: $password_token
            }
        ) {
            id
            email
            firstname
            lastname
            fullname
            is_active
            created_at
            updated_at
        }
    }
`

export const andcAccountLogin = gql`
    query andcAccountLogin (
        $email: String!
        $password: String!
    ) {
        andcAccountLogin (
            email: $email
            password: $password
        ) {
            client {
                id
                email
                firstname
                lastname
                fullname
                is_active
            }
            therapist {
                id
                type
                firstname
                lastname
                fullname
                email
                address
                postal_code
                telephone
                city
                state
                country
                region
                has_fill_clients_request_form
                is_active
            }
            session_token
        }
    }
`

export const clientLogout = gql`
    query clientLogout (
        $session_token: String!
    ) {
        clientLogout (
            session_token: $session_token
        ) {
            status
            message
        }
    }
`

export const validateSessionToken = gql`
    query validateSessionToken (
        $session_token: String!
    ) {
        validateSessionToken (
            session_token: $session_token
        ) {
            session_token
            client {
                id
                salutations
                firstname
                lastname
                email
                telephone
                address
                city
                postal_code
            }
        }
    }
`

export const updateClientProfile = gql`
    mutation updateClientProfile (
        $session_token: String!
        $input: ClientInput!
    ) {
        updateClient (
            session_token: $session_token
            input: $input
        ) {
            id
            salutations
            firstname
            lastname
            email
            telephone
            address
            city
            postal_code
        }
    }
`

export const requestPasswordReset = gql`
    mutation requestPasswordReset (
        $email: String!
    ) {
        requestPasswordReset (
            email: $email
        ) {
            status
            message
        }
    }
`



